// StatusGlyph kinds and their text colours, kept out of the component module (react-refresh/only-export-components).
export type GlyphKind = 'empty' | 'half' | 'full' | 'done' | 'clock' | 'alert' | 'up' | 'down';

/** The colour each glyph's SHAPE is drawn in. The schedule progression reads as progress, never grey:
 *  Confirmed hollow (meta outline) → Checked in HALF-filled blue → In room full blue → Done green check (shape green/500,
 *  the word in goodText). */
export const GLYPH_SHAPE: Record<GlyphKind, string> = {
  empty: 'var(--ink-meta)',
  half: 'var(--accent-primary)',
  full: 'var(--accent-primary)',
  done: 'var(--status-good)',
  clock: 'var(--status-attention)',
  alert: 'var(--status-bad)',
  up: 'var(--status-attention)',
  down: 'var(--status-attention)',
};

/** The text colour that goes with each glyph when the status is written beside it. */
export const GLYPH_TEXT: Record<GlyphKind, string> = {
  empty: 'var(--ink-secondary)',
  half: 'var(--ink-secondary)',
  full: 'var(--accent-active-text)',
  done: 'var(--status-good-text)', // the word in green/700 (AA on white); the check shape keeps green/500
  clock: 'var(--status-attention-text)',
  alert: 'var(--status-bad)',
  up: 'var(--status-attention-text)',
  down: 'var(--status-attention-text)',
};


/** A DS StatusChip semantic as a glyph (lane 8 cleanup c): status is a shape plus coloured words, never a tinted chip.
 *  Needs attention (warning) is the amber triangle, never red; only an error is the red alert. */
export const SEMANTIC_GLYPH: Record<'success' | 'warning' | 'error' | 'info' | 'neutral', GlyphKind> = {
  success: 'done',
  warning: 'up',
  error: 'alert',
  info: 'half',
  neutral: 'empty',
};
